import { GET_ORDER_ITEMS } from '../actionTypes/OrderActionTypes';

export const getOrderItems = (payload) => ({
    type: GET_ORDER_ITEMS,
    payload,
});

export default getOrderItems;
